<template>
  <div class="page-wrapper p-t-180 p-b-100 font-robo">
    <div class="wrapper wrapper--w960">
      <div class="card card-2">
        <div class="card-heading"></div>
        <div class="card-body">
          <h2 class="title">Online Application</h2>

          <div class="input-group">
            <input
              class="input--style-2"
              type="text"
              :class="{ 'is-invalid': $v.name.$error }"
              @input="$v.name.$touch()"
              v-model="name"
              placeholder="Name"
              name="name"
            />
            <div class="invalid-tooltip">
              <div v-if="$v.name.$error && !$v.name.required">
                This field is required.
              </div>
            </div>
          </div>
          <div class="input-group" style="position:relative">
            <label for="myfile" class="browse-photo">Photo</label>        
            <input
            id="myfile"
              class="input--style-2"
              type="file" 
              placeholder="Photography"             
              name="photo"
              @change="processFile($event)"
            />        
          </div>
          <div class="row row-space">
            <div class="col-2">
              <div class="input-group">
                <Select2
                  class="rs-select2"
                  :settings="{ minimumResultsForSearch: -1 }"
                  placeholder="Gender"
                  v-model="genderId"
                  :options="genders"
                  :class="{ 'is-invalid': $v.genderId.$error }"
                  @change="$v.genderId.$touch()"
                />
                <div class="invalid-tooltip">
                  <div v-if="!$v.genderId.required">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="input-group extra">
                <datepicker
                  placeholder="Birthdate"
                  class="input--style-2"
                  v-model="birthDate"
                  :bootstrapStyling="false"
                />
                <i
                  class="zmdi zmdi-calendar-note input-icon js-btn-calendar"
                ></i>
              </div>
            </div>
          </div>
          <div class="input-group">
            <input
              class="input--style-2"
              type="text"
              placeholder="Contact"
              v-model="contact"
              name="contact"
              :class="{ 'is-invalid': $v.contact.$error }"
              @input="$v.contact.$touch()"
            />
            <div class="invalid-tooltip">
              <div v-if="$v.contact.$error && !$v.contact.mobile">
                Invalid mobile no.
              </div>
            </div>
          </div>
          <div class="input-group">
            <input
              class="input--style-2"
              type="text"
              placeholder="Email"
              v-model="email"
              name="name"
              :class="{ 'is-invalid': $v.email.$error }"
              @input="$v.email.$touch()"
            />
            <div class="invalid-tooltip">
              <div v-if="$v.email.$error && !$v.email.required">
                This field is required.
              </div>
              <div v-if="$v.email.required && $v.email.$error">
                Invalid email address.
              </div>
            </div>
          </div>
          <div class="row row-space">
            <div class="col-2">
              <div class="input-group">
                <input
                  class="input--style-2"
                  type="text"
                  placeholder="Father Name"
                  name="fatherName"
                  v-model="fatherName"
                  :class="{ 'is-invalid': $v.fatherName.$error }"
                  @input="$v.fatherName.$touch()"
                />
                <div class="invalid-tooltip">
                  <div v-if="$v.fatherName.$error && !$v.fatherName.required">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="input-group">
                <input
                  class="input--style-2"
                  type="text"
                  placeholder="Contact"
                  name="fatherContact"
                  v-model="fatherContact"
                  :class="{ 'is-invalid': $v.fatherContact.$error }"
                  @input="$v.fatherContact.$touch()"
                />
                <div class="invalid-tooltip">
                  <div
                    v-if="$v.fatherContact.$error && !$v.fatherContact.mobile"
                  >
                    Invalid mobile no.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row row-space">
            <div class="col-2">
              <div class="input-group">
                <input
                  class="input--style-2"
                  type="text"
                  placeholder="Mother Name"
                  name="motherName"
                  v-model="motherName"
                  :class="{ 'is-invalid': $v.motherName.$error }"
                  @input="$v.motherName.$touch()"
                />
                <div class="invalid-tooltip">
                  <div v-if="$v.motherName.$error && !$v.motherName.required">
                    This field is required.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="input-group">
                <input
                  class="input--style-2"
                  type="text"
                  placeholder="Contact"
                  name="motherContact"
                  v-model="motherContact"
                  :class="{ 'is-invalid': $v.motherContact.$error }"
                  @input="$v.motherContact.$touch()"
                />
                <div class="invalid-tooltip">
                  <div
                    v-if="$v.motherContact.$error && !$v.motherContact.mobile"
                  >
                    Invalid mobile no.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input-group">
            <input
              class="input--style-2"
              type="text"
              placeholder="Address"
              name="address"
              v-model="address"
            />
          </div>
          <div class="input-group">
            <Select2
              class="rs-select2"
              :settings="{ minimumResultsForSearch: -1 }"
              placeholder="Teacher"
              v-model="selected.teacherId"
              :options="teachers"
              @change="onTeacherChange"                   
            />
            
          </div>
          <div class="input-group">
            <Select2
              class="rs-select2"
              :settings="{ minimumResultsForSearch: -1 }"
              placeholder="Subject"
              v-model="selected.subjectId"
              :options="subjects"
              @change="onSubjectChange"                
            />
            
          </div>
          <div class="input-group">
            <Select2
              class="rs-select2"
              :settings="{ minimumResultsForSearch: -1 }"
              placeholder="Batch"
              v-model="selected.batchId"
              :options="batches"
                
            />
            
          </div>

          <div>
            <button
              @click="add()"
              class="btn btn--radius btn--green"
              style="height: 30px; padding: 15px; line-height: 0; float:right;"
            >
              {{ added.length > 0 ? 'Add Another Batch' : 'Add Batch' }}
            </button>
          </div>

          <div class="batch-container">
            <table>
              <tr v-for="item in added" :key="item.batchId">
                <td>{{ item.subjectName }}</td>
                <td>{{ item.batchName }}</td>
              </tr>
            </table>
              <div class="invalid-tooltip">
                  <div v-if=" $v.batches.$error && !$v.batches.added">
                   NO BATCH ADDED YET!
                  </div>
                </div>
          </div>

          <div class="p-t-30">
            <button @click="save()" class="btn btn--radius btn--green">
              Submit Now
            </button>
          </div>
        </div>
      </div>
    </div>
        <sweet-modal icon="success" ref="successAlert">
      <h5>Application submitted successfully.</h5>
      <h2>Your application token is <strong>{{ tokenId }}</strong></h2>
    </sweet-modal>
     <sweet-modal icon="error" ref="errorAlert">
      <h5>Sorry for the inconvenience!</h5>
      <h2>Unable to submit the application!</h2>
    </sweet-modal>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import Datepicker from "vuejs-datepicker";
import { SweetModal } from 'sweet-modal-vue'
import { required,  email } from "vuelidate/lib/validators";
import DataService from '../services/data.service'
 import moment from 'moment'
export default {  
  components: { Select2, Datepicker,SweetModal },
  data() {
    return {
      tokenId: '',
      name: '',
      birthDate:  moment().toDate(),
      genders: [
        { id: 1, text: "Male" },
        { id: 2, text: "Female" },
      ],
      contact: '',
      email: '',
      fatherName: '',
      fatherContact: '',
      motherName: '',
      motherContact: '',
      address: '',
      teachers: [],
      subjects: [],
      batches: [],
      genderId: 1,
      selected: { teacherId: 0, subjectId: 0, batchId: 0 },
      added: [],      
      uploadPhoto: null,
      imagePath: ''
    };
  },
  created() {
    this.getTeachers()
    console.log('calling get teachers');
  },
  methods: {

 processFile(event) {
    this.uploadPhoto = event.target.files[0]
  },
    getTeachers(){
      DataService.getTeachers().then(res=>{
        console.log(res.data);
          this.teachers =res.data
      }).catch(err=> {
        this.teachers = null
        console.log(err)
      })
    },

    getSubjects(teacherId){
      DataService.getSubjects(teacherId).then(res=>{
          this.subjects =res.data
      }).catch(err=> {
        this.subjects = null
        console.log(err)
      })
    },

    getBatches(subjectId){
      DataService.getBatches(subjectId).then(res=>{
          this.batches =res.data
      }).catch(err=> {
        this.batches = null
        console.log(err)
      })
    },
    save() {

     

       this.$v.$touch()
      if (!this.$v.$invalid) {

    
        var data = new FormData();  
        data.append('name', this.name);
        data.append('genderId', this.genderId == 0 ? 1 : this.genderId),
        data.append('birthDate', moment(this.birthDate).format('YYYY-MM-DD'));
        data.append('contact', this.contact);
        data.append('email', this.email);
        data.append('fatherName', this.fatherName);
        data.append('fatherContact', this.fatherContact);
        data.append('motherName', this.motherName);
        data.append('motherContact', this.motherContact);
        data.append('address', this.address);

        data.append('photo', this.uploadPhoto);   


       let batchInfos = [];
      this.added.forEach(function (item) { 
        var info = item.batchId + '|' + item.subjectId + '|' + item.teacherId;
        batchInfos.push(info);
      });

        data.append('batches', batchInfos.join(','));

      DataService.save(data).then(res=>{      
          this.tokenId = res.data
          this.$refs.successAlert.open()
          this.clearForm()
          this.$v.$reset()
      }).catch(err=> 
        {
           this.$refs.errorAlert.open()
             console.log(err)      
        }    
      ) 
       
      
      
      }

    },

    onTeacherChange(id) {
     this.getSubjects(id)
    
    },
    onSubjectChange(id) {
      this.getBatches(id)
      
    },
    clearForm() {
      this.name = "";
      this.genderId = 1;
      this.birthDate = moment().toDate();
      this.contact = "";
      this.email = "";
      this.address = "";
      this.fatherName = "";
      this.fatherContact = "";
      this.motherName = "";
      this.motherContact = "";
      this.added = [],
       this.selected= { teacherId: 0, subjectId: 0, batchId: 0 }
       this.uploadPhoto = null
       
       this.imagePath = '';
    },
    add() {
      console.log(this.selected.batchId)
      if (this.selected.batchId == 0) return;
      if (this.added.length > 4) return;

      var teacher = this.teachers.find((t) => t.id == this.selected.teacherId);
      var subject = this.subjects.find((t) => t.id == this.selected.subjectId);
      var batch = this.batches.find((t) => t.id == this.selected.batchId);
      if (this.added.find((i) => i.batchId == batch.id)) return;

      this.added.push({
        teacherId: teacher.id,
        teacherName: teacher.text,
        subjectId: subject.id,
        subjectName: subject.text,
        batchId: batch.id,
        batchName: batch.text,
      });
      this.selected.batchId =0
    },
  },

  validations: {
    name: { required },
    fatherName: { required },
    motherName: { required },
    contact: {
      mobile(contact) {
        return /^(011|012|013|014|015|016|017|018|019)\d{8}$/.test(contact);
      },
    },
    fatherContact: {
      mobile(contact) {
        return /^(011|012|013|014|015|016|017|018|019)\d{8}$/.test(contact);
      },
    },
    motherContact: {
      mobile(contact) {
        return /^(011|012|013|014|015|016|017|018|019)\d{8}$/.test(contact);
      },
    },
    email: { required, email },
    genderId: { required },

    batches:  { added() {     
      return this.added.length > 0;
    }  },    
  },
};
</script>
<style scoped>
table {
  width: 100%;
}
td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  color: #808080;
  font-size: 16px;
  font-weight: 500;
}
.vdp-datepicker input {
  font-size: 16px;
  color: #808080;
  font-weight: 500;
}

.invalid-tooltip {
  color: red;
}

.sweet-modal-overlay {
  background-color: transparent !important;
}
.browse-photo {
  position:absolute;
  right: 10px;
  top: 5px;
      line-height: 36px;
    padding-left: 0;
    color: #808080;
    font-size: 16px;
    font-family: inherit;
    font-weight: 500;
}
</style>
